export const FONT_PAIRS = {
  'bold-modern': {
    id: 'bold-modern',
    label: 'Bold & Modern',
    description: 'High-impact, contemporary. Great for aggressive growth brands.',
    heading: "'Montserrat', sans-serif",
    headingWeight: 800,
    body: "'Inter', sans-serif",
  },
  'classic-trustworthy': {
    id: 'classic-trustworthy',
    label: 'Classic & Trustworthy',
    description: 'Established, dependable. Great for family-owned companies.',
    heading: "'Merriweather', serif",
    headingWeight: 900,
    body: "'Source Sans 3', sans-serif",
  },
  'clean-minimal': {
    id: 'clean-minimal',
    label: 'Clean & Minimal',
    description: 'Light, friendly, easy to read. Great for modern service brands.',
    heading: "'Poppins', sans-serif",
    headingWeight: 700,
    body: "'Open Sans', sans-serif",
  },
  'strong-industrial': {
    id: 'strong-industrial',
    label: 'Strong & Industrial',
    description: 'Rugged, tradesman-tough. Great for no-nonsense contractors.',
    heading: "'Oswald', sans-serif",
    headingWeight: 600,
    body: "'Roboto', sans-serif",
  },
};

export const DEFAULT_FONT_PAIR = 'bold-modern';

export const getFontPair = (id) => FONT_PAIRS[id] || FONT_PAIRS[DEFAULT_FONT_PAIR];
